import { useEffect, useMemo, useState } from "react";

// Each ray of the personal Sun is earned by a specific confirmation.
export const SUN_RAYS = [
  { key: "story", kind: "ray", label: "You told Spark why you're here", geom: [33, 33, 22, 21] },
  { key: "starting_point", kind: "ray", label: "Your Starting Point, confirmed", geom: [67, 33, 79, 20] },
  { key: "strengths", kind: "ray", label: "Strengths you've confirmed", geom: [33, 67, 21, 80] },
  { key: "values", kind: "ray", label: "Values you've named", geom: [67, 67, 80, 79] },
  { key: "energy", kind: "ray", label: "What gives and drains your energy", geom: [40, 24, 37, 14] },
  { key: "conditions", kind: "ray", label: "Your conditions for thriving", geom: [60, 76, 63, 86] },
  { key: "thread_1", kind: "ray", label: "Your first Gold Thread", geom: [76, 40, 86, 37] },
  { key: "thread_2", kind: "ray", label: "A second Gold Thread", geom: [24, 60, 14, 63] },
  { key: "narrative", kind: "dot", label: "An inner narrative, worked through", geom: [8, 50, 1.1] },
  { key: "direction", kind: "dot", label: "Your direction, chosen", geom: [20, 20, 0.9] },
  { key: "thread_3", kind: "dot", label: "A third Gold Thread", geom: [82, 82, 0.9] },
];

const has = (arr) => Array.isArray(arr) && arr.length > 0;

export const earnedRays = (profile) => {
  if (!profile) return [];
  const threads = profile.gold_threads_confirmed?.length || 0;
  const keys = [];
  if (profile.onboarded) keys.push("story");
  if (profile.starting_point_confirmed === "yes") keys.push("starting_point");
  if (has(profile.strengths)) keys.push("strengths");
  if (has(profile.values)) keys.push("values");
  if (has(profile.energy_sources) || has(profile.energy_drains)) keys.push("energy");
  if (has(profile.conditions_for_thriving)) keys.push("conditions");
  if (has(profile.limiting_narratives)) keys.push("narrative");
  if (profile.direction) keys.push("direction");
  if (threads >= 1) keys.push("thread_1");
  if (threads >= 2) keys.push("thread_2");
  if (threads >= 3) keys.push("thread_3");
  return keys;
};

const storageKey = (userId) => `spark_sun_seen:${userId}`;
const readSeen = (userId) => {
  try { return JSON.parse(localStorage.getItem(storageKey(userId)) || "[]"); } catch { return []; }
};

// Returns the earned ray keys plus the ones newly earned since last seen (to animate once).
export const useSunRays = (profile, userId) => {
  const earned = useMemo(() => earnedRays(profile), [profile]);
  const earnedSig = earned.join("|");
  const [seen, setSeen] = useState(() => readSeen(userId));

  useEffect(() => { setSeen(readSeen(userId)); }, [userId]);

  useEffect(() => {
    if (!profile) return undefined;
    const t = setTimeout(() => {
      localStorage.setItem(storageKey(userId), JSON.stringify(earned));
      setSeen(earned);
    }, 1800);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [earnedSig, userId, !!profile]);

  const fresh = earned.filter((k) => !seen.includes(k));
  return { earned, fresh, total: SUN_RAYS.length };
};
